module.exports = __webpack_public_path__ + "img/web_02_3.03c0ed64.png";